import React from 'react'
import { Route, Routes } from "react-router-dom";
import Transacciones from '../../Components/Customer/Transacciones/Transacciones'


/**
 * @export
 * @function PublicRoutes
 * @extends {Component}
 */
function RouterTransacciones(props) {

    

    return (
        <Routes>
            <Route path=""      element={<Transacciones {...props} />} />
        </Routes>
    )
}

export default RouterTransacciones;
